// Inscription
export const signUp = (creds) => {
  return (dispatch, getState, { getFirebase }) => {
    const firebase = getFirebase();

    firebase
      .auth()
      .createUserWithEmailAndPassword(creds.email, creds.password)
      .then(() => {
        dispatch({ type: 'SIGN_UP' });
      })
      .catch((err) => {
        dispatch({ type: 'SIGN_UP_ERR' }, err);
      });
  };
};

// Connexion
export const signIn = (creds) => {
  return (dispatch, getState, { getFirebase }) => {
    const firebase = getFirebase();

    firebase
      .auth()
      .signInWithEmailAndPassword(creds.email, creds.password)
      .then(() => {
        dispatch({ type: 'SIGN_IN' });
      })
      .catch((err) => {
        dispatch({ type: 'SIGN_IN_ERR' }, err);
      });
  };
};

// Déconnexion
export const signOut = () => {
  return (dispatch, getState, { getFirebase }) => {
    const firebase = getFirebase();

    firebase
    .auth()
    .signOut()
    .then(() => {
      dispatch({ type: 'SIGN_OUT' });
    });
  };
};

// Récupération le mot de passe
export const forgetPassword = (creds) => {
  return (dispatch, getState, { getFirebase }) => {
    const firebase = getFirebase();

    firebase
      .auth()
      .sendPasswordResetEmail(creds.email)
      .then(() => {
        dispatch({ type: 'FORGET_PASSWORD' });
      })
      .catch((err) => {
        dispatch({ type: 'FORGET_PASSWORD_ERR' }, err);
      });
  };
};
